import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { AiFillEdit, AiFillDelete } from 'react-icons/ai';
import { MdDone } from 'react-icons/md';
import { deleteTask, updateTaskTitle, toggleTaskStatus } from '../logic/utils';
const SingleTodo = ({ task, tasks, setTasks, taskLocation }) => {
    const [editMode, setEditMode] = useState(false);
    const [inputValue, setInputValue] = useState('');
    function replaceUpdatedTaskInList(updatedTask) {
        setTasks([...tasks.filter((t) => t.id !== task.id), updatedTask].sort((a, b) => a.title.localeCompare(b.title)));
    }
    function deleteHandler(task) {
        deleteTask(task.id, taskLocation)
            .then(() => setTasks(tasks.filter((t) => t.id !== task.id)))
            .catch((error) => { alert(`Unable to delete todo: ${String(error.message)}`); });
    }
    function editHandler(task) {
        setEditMode(false);
        updateTaskTitle(task, inputValue, taskLocation)
            .then((updatedTask) => replaceUpdatedTaskInList(updatedTask))
            .catch(() => alert('Update failed'));
    }
    function editModeHandler(task) {
        setInputValue(!editMode ? task.title : '');
        setEditMode(!editMode);
    }
    function statusHandler(task) {
        toggleTaskStatus(task, taskLocation)
            .then((updatedTask) => {
            replaceUpdatedTaskInList(updatedTask);
            // confirm('Todo status of ' + task.title + ' changed to ' + (updatedTask.status ? 'true' : 'false'))
        })
            .catch(() => { alert('Failed to change the status of the todo item'); });
    }
    return (_jsxs("form", { className: "todo-card", onSubmit: (e) => { e.preventDefault(); editHandler(task); }, children: [editMode
                ? (_jsx("input", { value: inputValue, onChange: (e) => setInputValue(e.target.value) }))
                : (_jsx("p", { className: task.status ? 'done' : '', children: task.title })), _jsx(AiFillEdit, { className: 'ml-auto icon', onClick: () => editModeHandler(task) }), _jsx(AiFillDelete, { className: 'icon', onClick: () => deleteHandler(task) }), _jsx(MdDone, { className: 'icon', onClick: () => statusHandler(task) })] }));
};
export default SingleTodo;
